//import logo from './logo.svg';
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Home from "./components/Home";
//import Products from "./components/Products";
import Services from "./components/Services";
import Location from "./components/Location";
import About from "./components/About";
import Shimadzu from "./components/Shimadzu";
import Genuine from "./components/Genuine";
import Pixxgen from "./components/Pixxgen";
import SocialMedia from "./components/SocialMedia";
import Construction from "./components/Construction";
import Gelpad from "./components/Gelpad";
import Portal from "./components/Portal";
import CustomerMap from "./components/CustomerMap";
import { FaPhoneAlt, FaTools } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import DemoFormModal from "./components/DemoFormModal";

function AppLayout() {
  const [showDemoModal, setShowDemoModal] = React.useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  return (
    <>
      <div className="App">
        {/* Modernized Navbar */}
        <Navbar className="navbar-color" expand="lg" variant="light">
          <Navbar.Brand as={Link} to="/home" className="d-flex align-items-center">
            <img
              className="navbar-logo navbar-logo--elevated me-3"
              src="/assets/logos/indelect-logo-nb.png"
              height="120"
              alt="Indelect Logo"
            />
          </Navbar.Brand>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/home">Home</Nav.Link>
              <NavDropdown title="Products" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="/shimadzu">Shimadzu</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/genuine">Genuine</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pixxgen">Pixxgen</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ctsp">
                  Neuro Surgical Stereotactic Device (CTSP)
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/gelpads">
                  Surgical Instruments and Gel Pads
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/services">Services</Nav.Link>
              <Nav.Link as={Link} to="/customers">Customers</Nav.Link>
              <Nav.Link as={Link} to="/location">Location</Nav.Link>
              <Nav.Link as={Link} to="/about">About</Nav.Link>
              <Nav.Link as={Link} to="/portal">Portal</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {isHomePage && (
          <section className="home-contact-section">
            <div className="home-contact-item">
              <span className="home-contact-icon" aria-label="Sales"><FaPhoneAlt /></span>
              <span className="contact-title">Sales</span>
              <span className="contact-number">+91 93802 43402</span>
            </div>
            <div className="home-contact-item">
              <span className="home-contact-icon" aria-label="Service"><FaTools /></span>
              <span className="contact-title">Service</span>
              <span className="contact-number">+91 93825 43299</span>
            </div>
            <div className="home-contact-item">
              <span className="home-contact-icon" aria-label="Email"><MdEmail /></span>
              <span className="contact-title">Email</span>
              <span className="contact-email"><a href="mailto:salesindelect@gmail.com">salesindelect@gmail.com</a></span>
            </div>
            <div className="home-contact-item">
              <button
                className="schedule-demo-btn"
                onClick={() => setShowDemoModal(true)}
              >
                Schedule Demo
              </button>
            </div>
            <div className="home-contact-item">
              <SocialMedia />
            </div>
            <DemoFormModal show={showDemoModal} onClose={() => setShowDemoModal(false)} />
          </section>
        )}
      </div>
      <hr />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/shimadzu" element={<Shimadzu />} />
        <Route path="/genuine" element={<Genuine />} />
        <Route path="/pixxgen" element={<Pixxgen />} />
        <Route path="/ctsp" element={<Construction />} />
        <Route path="/gelpads" element={<Gelpad />} />
        <Route path="/services" element={<Services />} />
        <Route path="/customers" element={<CustomerMap />} />
        <Route path="/location" element={<Location />} />
        <Route path="/about" element={<About />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/" element={<Home />} />
      </Routes>
      <hr />
      <footer className="text-center text-lg-start bg-white text-muted mt-4 shadow-sm rounded-top site-footer">
  <div className="text-center p-4">
    © 2025
    <a className="text-reset fw-bold ms-2" href="https://www.indelect.com"> www.indelect.com</a>
  </div>
</footer>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
